export default {
  data: () => ({
    snackbar: {
      show: false,
      timeout: 3000,
      text: "",
      color: "red"
    }
  }),
  methods: {
    showSnack() {
      this.snackbar.text = this.error;
      this.snackbar.color = "red";
      this.snackbar.timeout = 3000;
      this.snackbar.show = true;
    },
    successSnack(text) {
      this.snackbar.text = text;
      this.snackbar.color = "green";
      this.snackbar.timeout = 2000;
      this.snackbar.show = true;
    },
    warningSnack(text) {
      this.snackbar.text = text;
      this.snackbar.color = "yellow";
      this.snackbar.timeout = 2000;
      this.snackbar.show = true;
    },
    errorSnack(text) {
      this.snackbar.text = text;
      this.snackbar.color = "red";
      this.snackbar.timeout = 3000;
      this.snackbar.show = true;
    }
  }
};
